<template>
  <dialog class="modal" :open="open">
    <div class="modal-box container">
      <h3 class="text-lg font-bold">Chi tiết brute-force</h3>
      <div class="py-4">
        <div v-if="result">
          <div
            v-for="(detail, index) in result.bruteforce"
            :key="index"
            class="mb-4 border p-4"
          >
            <div class="grid grid-cols-1 gap-4 2xl:grid-cols-2">
              <div class="flex items-center gap-2">
                <strong>{{ detail.id }}</strong>
                <ActionStatusBadge :status="detail.status" />
              </div>
            </div>
            <div class="mt-4">
              <h4 class="font-semibold">Tiến trình brute-force:</h4>
              <div class="mt-2">
                <div class="flex justify-between">
                  <div class="flex w-14 flex-col items-center">
                    <div class="bg-info h-4 w-4 rounded-full"></div>
                    <span class="mt-1 text-xs">Ra lệnh</span>
                    <span class="mt-1 text-xs">{{
                      dayjs(detail.time).format("YYYY/MM/DD")
                    }}</span>
                    <span class="mt-1 text-xs">
                      {{ dayjs(detail.time).format("HH:mm:ss") }}
                    </span>
                  </div>
                  <div class="flex w-14 flex-col items-center">
                    <div class="bg-warning h-4 w-4 rounded-full"></div>
                    <span class="mt-1 text-xs">Bắt đầu</span>
                    <span class="mt-1 text-xs">
                      {{ dayjs(detail.time_brute_force).format("YYYY/MM/DD") }}
                    </span>
                    <span class="mt-1 text-xs">{{
                      dayjs(detail.time).format("HH:mm:ss")
                    }}</span>
                  </div>
                  <div class="flex w-16 flex-col items-center">
                    <template v-if="detail.completed">
                      <div class="bg-success h-4 w-4 rounded-full"></div>
                      <span class="mt-1 text-xs">Hoàn thành</span>
                      <span class="mt-1 text-xs">
                        {{ dayjs(detail.completed).format("YYYY/MM/DD") }}
                      </span>
                      <span class="mt-1 text-xs">
                        {{ dayjs(detail.time).format("HH:mm:ss") }}
                      </span>
                    </template>
                  </div>
                </div>
              </div>
            </div>

            <!-- Kết quả bruteforce -->
            <div class="mt-4" v-if="detail.result && detail.result.length > 0">
              <h4 class="font-semibold">Kết quả:</h4>
              <div class="mt-2 grid grid-cols-1 gap-2">
                <div
                  v-for="(resultItem, idx) in detail.result"
                  :key="idx"
                  class="card bg-base-100 border shadow-sm"
                >
                  <div class="card-body px-4 py-3">
                    <div class="grid grid-cols-1 gap-1 text-sm">
                      <p><strong>IP:</strong> {{ resultItem.ip }}</p>
                      <p><strong>Username:</strong> {{ resultItem.us }}</p>
                      <p><strong>Password:</strong> {{ resultItem.ps }}</p>
                      <p><strong>Loại:</strong> {{ resultItem.type }}</p>
                      <p>
                        <strong>Kết quả:</strong>
                        <span
                          :class="
                            resultItem.ret
                              ? 'badge badge-success badge-outline'
                              : 'badge badge-error badge-outline'
                          "
                        >
                          {{ resultItem.ret ? "Thành công" : "Thất bại" }}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-action">
        <button class="btn" @click="handleClose">Đóng</button>
      </div>
    </div>
  </dialog>
</template>

<script setup lang="ts">
import ActionStatusBadge from "@/components/ActionStatusBadge.vue";
import dayjs from "dayjs";

interface BruteForceResult {
  id: string;
  agent_id: string;
  scan_id: string;
  ip: string;
  username: string;
  password: string;
  created: number;
  modified: number;
  bruteforce?: {
    id: string;
    time: Date;
    status: string;
    time_brute_force: Date;
    completed: Date;
    result: {
      ip: string;
      ps: string;
      ret: boolean;
      type: string;
      us: string;
    }[];
  }[];
}

interface Props {
  open: boolean;
  result?: BruteForceResult | null;
}

defineProps<Props>();

const emit = defineEmits<{
  "update:open": [value: boolean];
}>();

const handleClose = () => {
  emit("update:open", false);
};
</script>
